<div class="stepper-wrapper">
    <div class="label">{{label}}</div>
    <div class="stepper-row">
        <ng-content></ng-content>
    </div>
</div>